// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"24682":"ffdff81503e5e767","30802":"7b49ec900606c648","36487":"f8b2ce9c597436a2","39760":"55d10574aea46c02","55682":"2f9091f4bb6fec9d","86106":"72f523c0971f3952"}[chunkId] + ".css";
};